import { Autocomplete } from "@mui/material";
import React from "react";
import { EntityIcon } from "src/components/generics/icons/entityIcon/EntityIcon";
import { OrganizationLink, PosLink, UserLink } from "src/components/generics/links";
import { SearchType } from "src/components/generics/nestedSelect/NestedSelect";
import { SearchInput } from "src/components/generics/SearchInput/SearchInput";
import type { Organization } from "src/types/organization";
import type { Pos } from "src/types/pos";
import type { UserBase } from "src/types/user";

import { useTranslation } from "src/design-system/core/TranslationContext";
import { useSuperAdminSearchBar } from "./SuperAdminSearchBar.hook";
import { useSuperAdminSearchBarStyles } from "./SuperAdminSearchBar.styles";

export const SuperAdminSearchBar = (): JSX.Element => {
    const classes = useSuperAdminSearchBarStyles();
    const [open, setOpen] = React.useState(false);
    const { elements, isPending, handleChangeAdminSearchBar } = useSuperAdminSearchBar(open);
    const { translateCommon } = useTranslation();

    return (
        <Autocomplete
            options={elements}
            getOptionLabel={(option) => option.label}
            loading={isPending}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            classes={{
                root: classes.root,
                option: classes.optionContainer,
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <SearchInput
                    placeholder={translateCommon("actions.search")}
                    handleChange={handleChangeAdminSearchBar}
                    textFieldProps={params}
                />
            )}
            getOptionKey={(option) => {
                return option.key;
            }}
            renderOption={(_props, option) => (
                <div key={option.key}>
                    {
                        {
                            [SearchType.Organization]: (
                                <OrganizationLink
                                    organization={option.value as Organization}
                                    Icon={<EntityIcon type={SearchType.Organization} />}
                                    className={classes.option}
                                />
                            ),
                            [SearchType.PointOfSales]: (
                                <PosLink
                                    pos={option.value as Pos}
                                    Icon={<EntityIcon type={SearchType.PointOfSales} />}
                                    className={classes.option}
                                />
                            ),
                            [SearchType.User]: (
                                <UserLink
                                    user={option.value as UserBase}
                                    Icon={<EntityIcon type={SearchType.User} />}
                                    className={classes.option}
                                />
                            ),
                        }[option.type]
                    }
                </div>
            )}
        />
    );
};
